import DOMPurify from 'dompurify'
import Swal from 'sweetalert2'
import '@sweetalert2/theme-bootstrap-4/bootstrap-4.scss';
import './sweet-alert-hack.scss';
import axios from 'axios'
import { 
    mixinsFactory,
    mixinsHelp
} from './TablePagesMixins'

import CommonService from './CommonService.js'
import EcomProductCard from './EcomProductCard.vue'
import EcomService from './EcomService.js'
import WnButton from './WnButton.vue'
import WnModal from './WnModal.vue'
import WnDialog from './WnDialog.vue'
import WnSelect from './WnSelect.vue'
import WnCart from './EcomCartWidget.vue'
import WnPages from './WnPages.vue'
import WnTablePages from './WnTablePages.vue'
import WnTableHeaderCell from './WnTableHeaderCell.vue'
import WnTableColvis from './WnTableColvis.vue'
import WnDropDown from './WnDropDown.vue'
import WnTableToolbar from './WnTableToolbar.vue'
import WnListTabs from './WnListTabs.vue'
import WnFilterPanel from './WnFilterPanel.vue'
import WnFilterTrigger from './WnFilterTrigger.vue'
import WnDatePicker from './WnDatePicker.vue'
import WnEditor from './WnEditor.vue'
import WnChoices from './WnChoices.vue'
import WnUpload from './WnUpload.vue'
import { formatCurrency } from '../common/formatCurrency';
import billingOperators from '../common/billingOperators';
import AddToCartWidget from './AddToCartWidget.vue'
import LoginDrawer from './LoginDrawer.vue'
import BS5Tooltip from './BS5Tooltip.js'

const { formatDateTime, dateFormat, getDateFormat, CURRENCY_SYMBOL } = window.wisenetwork
const sanitizeHtml = (html) => DOMPurify.sanitize(html)

const defaultSwalMixin = Swal.mixin({
    customClass: {
        htmlContainer: '',
        container: 'wise-sweet-alert',
        confirmButton: 'btn btn-lg btn-success',
        cancelButton: 'btn btn-lg btn-default',
        denyButton: 'btn btn-lg btn-default',
    },
    buttonsStyling: false,
    reverseButtons: true,
})

/**
 * Some mapping provided from old swal options to new format.
 *  
 * @param {Object} options 
 * @returns {Promise}
 */
function swalFire(options) {
    return defaultSwalMixin.fire({
        ...options,
    })
}

const components = {
    WnButton,
    // WnModal and WnDialog have similar API, so when changing from BS3 to BS5, modals should just work
    WnModal: window.wisenetwork?.bootstrap3 ? WnModal : WnDialog,
    WnSelect,
    WnCart,
    AddToCartWidget,
    EcomProductCard,
    LoginDrawer,
    WnPages,
    WnTablePages,
    WnTableHeaderCell,
    WnTableColvis,
    WnDropDown,
    WnTableToolbar,
    WnListTabs,
    WnFilterPanel,
    WnFilterTrigger,
    WnDatePicker,
    WnEditor,
    WnChoices,
    WnUpload,
}

const directives = {
    wntooltip: BS5Tooltip,
}

function normalizeAppContext(app) {
    if (window.Vue?.version?.startsWith('2')) {
        return app.prototype
    }
    return app.config.globalProperties
}

export default {
    install(app, context) {
        const appContext = normalizeAppContext(app)

        appContext.$_locale = (placeholder, firstUpper = true, injection = null) => {
            const translation = window._locale(placeholder, injection);
            
            if (firstUpper) {
                return translation.ucfirst();
            }
            
            return translation;
        };
        appContext.$_swal = swalFire;
        appContext.$_swalInstance = Swal;
        appContext.$_formatCurrency = formatCurrency;
        appContext.$_CURRENCY_SYMBOL = CURRENCY_SYMBOL;
        appContext.$_formatDateTime = formatDateTime;
        appContext.$_dateFormat = dateFormat;
        appContext.$_getDateFormat = getDateFormat;
        appContext.$_localeDates = window._localeDates;
        appContext.$_http = axios;
        appContext.$_sanitizeHtml = sanitizeHtml;
        appContext.$_CommonService = CommonService;
        appContext.$_EcomService = EcomService;
        appContext.$_billingOperators = billingOperators.map((operator) => {
            operator.text = `${operator.text} (${operator.value})`
            
            return operator
        })
        appContext.$_getCountries = async () => Object.keys(window.countries || {})
        .map(row => ({
            id: row,
            text: window.countries[row]
        }));
        
        Object.keys(components).forEach((name) => {
            const component = components[name]
    
            app.component(name, component)  
        })
        
        Object.keys(directives).forEach((name) => {
            const directive = directives[name]
    
            app.directive(name, directive)
        })
        
        if (typeof context !== 'undefined') {
            //store.registerModule('common', CommonStore)
        }
    },
    mixinsFactory,
    mixinsHelp,
}